import { Icon } from "@iconify/react";

// ----------------------------------------------------------------------

const navConfig = [
  {
    title: "dashboard",
    path: "/dashboard",
    icon: <Icon icon="mdi:view-dashboard-outline" width="24" height="24" />,
  },
  {
    title: "report issue",
    path: "/reportissue",
    icon: <Icon icon="ic:outline-report" width="28" height="28" />,
  },
  {
    title: "check status",
    path: "/checkstatus",
    icon: <Icon icon="fluent-mdl2:sync-status" width="24" height="24" />,
  },
  // {
  //   title: "API",
  //   path: "/API",
  //   icon: <Icon icon="tabler:api-app" width="28" height="28" />,
  // },
  {
    title: "Escalation Matrix",
    path: "/escalation",
    icon: <Icon icon="ri:customer-service-2-line" width="28" height="28" />,
  },
  {
    title: "User Manual",
    path: "/usermanual",
    icon: <Icon icon="bi:file-pdf" width="28" height="28" />,
  },
];

export default navConfig;
